// ==============================
// TYPES
// ==============================
export type THeaderContext = 'biz' | 'comp' | null;
export type THeaderKey = Exclude<THeaderContext, null>; // 'biz' | 'comp'

// ==============================
// CONFIG
// ==============================
export const HEADER_PATH_CONFIG: Record<THeaderKey, string[]> = {
  biz: ['/business/company', '/company'],
  comp: ['/commerce', '/broadcast', '/order/delivery', '/reply-template', '/social-channel', '/team', '/line'],
};

// ⚠️ IMPORTANT:
// - ต้อง specific กว่า HEADER_PATH_CONFIG
// - จะถูก check ก่อนเสมอ
const EXCLUDE_PATHS = ['/line/friend', '/company/running-number'];

// ==============================
// HELPERS
// ==============================
function isExcluded(pathname: string): boolean {
  return EXCLUDE_PATHS.some((exclude) => pathname === exclude || pathname.startsWith(exclude + '/'));
}

// ==============================
// MAIN FUNCTION
// ==============================
export function getHeaderContext(url: string): THeaderContext {
  if (!url) return null;

  // รองรับทั้ง full URL และ relative URL
  const pathname = url.startsWith('http') ? new URL(url).pathname : url;

  // ✅ 1. check exclude ก่อน (กัน false match)
  if (isExcluded(pathname)) {
    return null;
  }

  // ✅ 2. loop config แบบ type-safe
  for (const key of Object.keys(HEADER_PATH_CONFIG) as THeaderKey[]) {
    const prefixes = HEADER_PATH_CONFIG[key];

    for (const prefix of prefixes) {
      if (pathname.startsWith(prefix)) {
        return key; // 'biz' | 'comp'
      }
    }
  }

  return null;
}
